import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "lock" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M4.49922 8.10078C4.49922 5.14637 5.95369 1.80078 8.99922 1.80078C12.0448 1.80078 13.4992 5.14637 13.4992 8.10078M2.69922 8.70507V15.5965C2.69922 15.9302 2.96977 16.2008 3.3035 16.2008H14.6949C15.0287 16.2008 15.2992 15.9302 15.2992 15.5965V8.70507C15.2992 8.37133 15.0287 8.10078 14.6949 8.10078H3.3035C2.96977 8.10078 2.69922 8.37133 2.69922 8.70507Z",
        stroke: "#AA1E2D",
        "stroke-width": "1.4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }